import { render } from "./HeadComp.vue?vue&type=template&id=a2001ff4&scoped=true"
import script from "./HeadComp.vue?vue&type=script&lang=js"
export * from "./HeadComp.vue?vue&type=script&lang=js"

import "./HeadComp.vue?vue&type=style&index=0&id=a2001ff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2001ff4"]])

export default __exports__